import { setPageTitle } from '@/lib/appInsights';
import { Bell } from 'lucide-react';
import { FaReceipt } from 'react-icons/fa';
import Section from '@/components/elements/Section';
import Notifications from '@/components/settings/Notifications';
import { Tabs, TabsList, TabsTrigger } from '@/components/elements/Tabs';
import Subscriptions from '@/components/settings/Subscriptions';
import { usePaywall } from '@/hooks/usePaywall';
import { SubscriptionStatus } from '@/constants/constants';
import type { PaywallContextType } from '@/types/util.types';
import { useEffect, useState } from 'react';
import { NotificationSettingsAuthor } from '@/types/models.types';

function Settings() {
  setPageTitle('Settings');
  const { subscriptions, isLoading, getNotificationSettingsAuthors } = usePaywall() as PaywallContextType;
  const [authors, setAuthors] = useState<NotificationSettingsAuthor[]>([]);

  const activeSubscriptions = subscriptions.filter(
    (subscription) => subscription.status !== SubscriptionStatus.Expired
  );

  async function fetchAuthors() {
    try {
      const authorsData = await getNotificationSettingsAuthors();
      setAuthors(authorsData);
    } catch (error) {
      console.error('Error fetching authors:', error);
    }
  }

  useEffect(() => {
    fetchAuthors();
  }, []);

  return (
    <Section
      title='Settings'
      headingLevel='h1'
      background='white'
      description='Manage your subscriptions and notification settings.'
    >
      <Tabs defaultValue='subscriptions' className='mt-6'>
        <TabsList className='mb-6'>
          <TabsTrigger value='subscriptions' icon={<FaReceipt />}>
            Subscriptions
          </TabsTrigger>
          <TabsTrigger
            icon={<Bell />}
            value='notifications'
            disabled={activeSubscriptions.length === 0 || authors.length === 0}
          >
            Notifications
          </TabsTrigger>
        </TabsList>

        <Subscriptions subscriptions={activeSubscriptions} isLoading={isLoading} />
        {activeSubscriptions.length > 0 && <Notifications authors={authors} />}
      </Tabs>
    </Section>
  );
}

export default Settings;
